<template>
  <div>
    <div class="conditions">
      <table-columns-sidesheet
        ref="tableColumnsModal"
        :columns="columns"
        @apply="saveConditionColumns"
      ></table-columns-sidesheet>
      <draggable
        v-model="localValue"
        tag="div"
        ghost-class="sortable__ghost"
        class="item-container"
        handle=".handle"
        :force-fallback="true"
      >
        <div v-for="(condition, i) in localValue" :key="condition.unique" class="condition">
          <div class="condition__border">
            <div class="condition__wrapper">
              <div v-if="localValue.length > 1" class="condition__move handle">
                <c-button-2 size="iconic" icon="arrows-constructor" />
              </div>
              <div class="condition__content">
                <div class="condition__title">
                  <svg-icon
                    class="condition__toggle"
                    name="chevron-top-circled"
                    :class="{
                      open: condition.opened,
                    }"
                    :size="24"
                    color="primary"
                    @click="$set(condition, 'opened', !condition.opened)"
                  ></svg-icon>
                  Условие {{ i + 1 }}
                  <c-button-2
                    class="condition__remove desktop"
                    size="iconic"
                    :icon="{ icon: 'trash', color: 'secondary' }"
                    @click="removeCondition(condition)"
                  />
                  <c-button
                    class="condition__remove mobile"
                    label="Удалить"
                    :icon="{ icon: 'trash', color: 'secondary' }"
                    @click="removeCondition(condition)"
                  />
                  <c-button-2
                    v-if="localValue.length > 1"
                    class="move handle"
                    size="iconic"
                    icon="arrows-constructor"
                  />
                </div>
                <transition name="slide">
                  <div v-show="condition.opened" class="condition__data">
                    <div class="condition__selects">
                      <c-input
                        v-model="condition.roles"
                        class="condition__roles"
                        type="select"
                        label="Роли"
                        :items="roles"
                        :multiple="true"
                        :searchable="true"
                        placeholder="Выбрать роль"
                      ></c-input>
                      <span class="condition__selects-divider">или</span>
                      <c-input
                        v-model="condition.posts"
                        class="condition__posts"
                        type="select"
                        label="Должности"
                        :items="posts"
                        :multiple="true"
                        :searchable="true"
                        placeholder="Выбрать должность"
                      ></c-input>
                    </div>
                    <div class="condition__columns">
                      <h-button
                        :disabled="!condition.posts.length && !condition.roles.length"
                        @click="setConditionColumns(condition, i)"
                      >
                        Настроить столбцы
                        <span class="columns-count">{{ getColumnsLength(condition.columns) }}</span>
                      </h-button>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls/button";
import CButton2 from "@/components/controls2/Button";
import HButton from "@/components/button";
import SvgIcon from "@/components/svg-icon";
import TableColumnsSidesheet from "@/components/modals/table-columns/sidesheet";
import { Condition } from "./condition-model";

export default {
  components: {
    draggable,
    CInput,
    HButton,
    TableColumnsSidesheet,
    CButton,
    SvgIcon,
    "c-button-2": CButton2,
  },
  props: ["conditions", "columns"],

  data() {
    return {
      localValue: [],
    };
  },

  computed: {
    roles() {
      return this.$store.state.tablesSettings.roles;
    },
    posts() {
      return this.$store.state.tablesSettings.posts;
    },
    defaultColumnsSet() {
      return this.columns.filter((c) => !c.isCategory).map((c) => c.id);
    },
    columnCategories() {
      return this.columns.filter((c) => c.isCategory).map((c) => c.id);
    },
  },

  created() {
    Promise.all([
      this.$store.dispatch("tablesSettings/getPosts"),
      this.$store.dispatch("tablesSettings/getRoles"),
    ]).then(() => {
      this.localValue = (this.conditions || []).map((c) => new Condition(c));
    });
  },

  methods: {
    removeCondition(condition) {
      this.localValue = this.localValue.filter((c) => c !== condition);
    },

    getColumnsLength(columns) {
      let cotegoriesCount = 0;

      columns.forEach((c) => {
        if (this.columnCategories.includes(c)) {
          cotegoriesCount += 1;
        }
      });

      return columns.length - cotegoriesCount;
    },

    addCondition() {
      const condition = new Condition();
      condition.columns = this.defaultColumnsSet;
      const conditions = [...this.localValue, condition];
      this.localValue = conditions;
    },

    setConditionColumns(condition, index) {
      this.$refs.tableColumnsModal.open(condition.unique, {
        columns: condition.columns,

        title: `Столбцы условия ${index + 1}`,
      });
    },

    saveConditionColumns({ id, selected }) {
      this.localValue = this.localValue.map((c) => {
        if (c.unique === id) {
          c.columns = selected;
        }
        return c;
      });
    },

    getConditions() {
      return this.localValue
        .filter((c) => c.roles.length || c.posts.length)
        .map((c, i) => {
          const condition = c.getData();
          condition.name = `Условие ${i + 1}`;
          return condition;
        });
    },

    update(conditions) {
      this.localValue = (conditions || []).map((c) => new Condition(c));
    },
  },
};
</script>
<style lang="scss" scoped src="./style.scss"></style>
